import { Box, styled } from "@mui/material";

const PREFIX = "KHeaderWidgetBurger";

export const classes = {
  root: `${PREFIX}-root`,
  burgerIconButton: `${PREFIX}-burgerIconButton`,
  wall: `${PREFIX}-wall`,
  sidebar: `${PREFIX}-sidebar`,
  sidebarPaper: `${PREFIX}-sidebarPaper`,
  closeButton: `${PREFIX}-closeButton`,
};

export const StyledKHeaderWidgetBurger = styled(Box)<{ isOpen: boolean }>(
  ({ theme, isOpen: _isOpen }) => ({
    [`&.${classes.root}`]: {
      gridArea: "burger",
      display: "flex",
      alignItems: "center",
    },

    [`& .${classes.burgerIconButton}`]: {},

    [`& .${classes.wall}`]: {
      position: "fixed",
      width: "100vw",
      height: "100vh",
      background: "rgba(0, 0, 0, 0.7)",
      top: 0,
      left: 0,
      zIndex: theme.zIndex.drawer,
      backgroundColor: "rgba(0,0,0,0.75)",
      backdropFilter: "blur(5px)",
      display: "flex",
      alignItems: "stretch",
      justifyContent: "flex-start",
    },

    [`& .${classes.sidebar}`]: {
      display: "flex",
      // maxWidth: "calc(100vw - 2rem)",
      position: "relative",
    },

    [`& .${classes.sidebarPaper}`]: {
      padding: theme.spacing(2),
      borderRadius: 0,
      width: "100%",
    },

    [`& .${classes.closeButton}`]: {},
  }),
);
